import { TopicData } from '~/types/theory'
import { GridPosition, HexElementProperties } from '~/types/drill'

import { ProcessedTopic } from './types'

export function processTopics(
  topics: TopicData[] | undefined,
  getGridPosition: (index: number) => GridPosition,
  getProperties: (index: number) => HexElementProperties,
): ProcessedTopic[] | undefined {
  return topics?.map((elem, index) => ({
    ...elem,
    gridPosition: getGridPosition(index),
    properties: getProperties(index),
  }))
}

export function getMobileGridPosition(index: number): GridPosition {
  const rowPosition = [index * 2 + 1, index * 2 + 3]
  let colPosition = [0, 0]

  if (index % 2 === 0) {
    colPosition = [1, 3]
  }

  if (index % 2 === 1) {
    colPosition = [2, 4]
  }

  return {
    gridColumnStart: colPosition[0],
    gridColumnEnd: colPosition[1],
    gridRowStart: rowPosition[0],
    gridRowEnd: rowPosition[1],
  }
}

export function getTabletGridPosition(index: number): GridPosition {
  let colPosition = [0, 0]
  let rowPosition = [0, 0]

  switch (index) {
    case 0:
      colPosition = [2, 4]
      rowPosition = [1, 3]
      break

    case 1:
      colPosition = [4, 6]
      rowPosition = [1, 3]
      break

    case 2:
      colPosition = [6, 8]
      rowPosition = [1, 3]
      break

    case 3:
      colPosition = [7, 9]
      rowPosition = [3, 5]
      break

    case 4:
      colPosition = [6, 8]
      rowPosition = [5, 7]
      break

    case 5:
      colPosition = [4, 6]
      rowPosition = [5, 7]
      break

    case 6:
      colPosition = [2, 4]
      rowPosition = [5, 7]
      break

    case 7:
      colPosition = [1, 3]
      rowPosition = [7, 9]
      break

    case 8:
      colPosition = [2, 4]
      rowPosition = [9, 11]
      break

    case 9:
      colPosition = [4, 6]
      rowPosition = [9, 11]
      break

    case 10:
      colPosition = [6, 8]
      rowPosition = [9, 11]
      break

    case 11:
      colPosition = [7, 9]
      rowPosition = [11, 13]
      break

    case 12:
      colPosition = [6, 8]
      rowPosition = [13, 15]
      break

    case 13:
      colPosition = [4, 6]
      rowPosition = [13, 15]
      break

    case 14:
      colPosition = [2, 4]
      rowPosition = [13, 15]
      break

    case 15:
      colPosition = [1, 3]
      rowPosition = [15, 17]
      break

    case 16:
      colPosition = [2, 4]
      rowPosition = [17, 19]
      break

    case 17:
      colPosition = [4, 6]
      rowPosition = [17, 19]
      break

    case 18:
      colPosition = [6, 8]
      rowPosition = [17, 19]
      break

    case 19:
      colPosition = [7, 9]
      rowPosition = [19, 21]
      break

    case 20:
      colPosition = [6, 8]
      rowPosition = [21, 23]
      break

    case 21:
      colPosition = [4, 6]
      rowPosition = [21, 23]
      break

    case 22:
      colPosition = [2, 4]
      rowPosition = [21, 23]
      break

    case 23:
      colPosition = [1, 3]
      rowPosition = [23, 25]
      break

    default:
      break
  }

  return {
    gridColumnStart: colPosition[0],
    gridColumnEnd: colPosition[1],
    gridRowStart: rowPosition[0],
    gridRowEnd: rowPosition[1],
  }
}
